import { jsx as _jsx } from "react/jsx-runtime";
import { DataTable, IconButton, Switch, Text, Tooltip, } from '@dixa/lib-shared-habla';
import { ScoreIcon } from 'fable/ScoreIcon';
export const LanguageCustomizationList = ({ languages, disabled, notAllowedToBeDisabledLanguages, onEdit, onLanguageStatusChange, }) => {
    return (_jsx(DataTable, { data: languages, columns: [
            {
                label: 'Language',
                selector: (language) => (_jsx(Text.Paragraph, Object.assign({ color: language.isSetup ? 'primary' : 'tertiary' }, { children: language.name }))),
            },
            {
                label: 'Rating style',
                selector: (language) => language.ratingStyle ? (_jsx(ScoreIcon, { score: 5, style: language.ratingStyle, size: 25 }, `${language.code}-rating-style`)) : null,
            },
            {
                label: 'Enabled',
                selector: (language) => {
                    if (language.isSetup) {
                        return (_jsx(Switch, { name: language.code, value: language.code, checked: language.enabled, disabled: disabled ||
                                (language.enabled &&
                                    (notAllowedToBeDisabledLanguages === null || notAllowedToBeDisabledLanguages === void 0 ? void 0 : notAllowedToBeDisabledLanguages.includes(language.code))), onChange: () => onLanguageStatusChange({
                                language,
                                newStatus: !language.enabled,
                            }) }));
                    }
                },
                style: {
                    width: 0,
                },
            },
            {
                label: '',
                selector: (language) => {
                    return (_jsx(Tooltip, Object.assign({ content: language.isSetup ? 'Edit' : 'Setup', dark: true }, { children: _jsx(IconButton, { icon: language.isSetup ? 'pen' : 'cog', variant: "tertiary", onClick: () => onEdit(language), disabled: disabled }) })));
                },
                style: {
                    width: 0,
                },
            },
        ] }));
};
